"use client";

import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";

export default function LuMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, logo } = league || {};

  return (
    <div className="w-full overflow-hidden rounded-xl border border-[var(--theme-border)] stake-bg-header">
      <button
        type="button"
        onClick={() => setIsExpanded((prev) => !prev)}
        className="kbv-lu-league-header relative flex w-full items-start gap-2 rounded-t-[12px] bg-[#d2ffee] pl-4 pr-5 py-2 text-left md:pl-3 md:pr-3"
        aria-expanded={isExpanded}
      >
        <div className="hidden min-w-0 flex-1 w-full md:grid md:grid-cols-[minmax(220px,1fr)_152px_152px_152px] md:gap-x-3 md:items-center">
          <div className="text-scale-title flex min-w-0 items-center gap-2 text-[14px] font-bold leading-5 text-[var(--theme-text)]">
            {logo ? (
              <img
                src={logo}
                alt={name || "league"}
                className="h-4 w-4 shrink-0 object-contain"
                width={16}
                height={16}
                loading="lazy"
              />
            ) : null}
            <span className="truncate">{name}</span>
          </div>
          <div className="flex w-full justify-center text-sm font-semibold text-[var(--theme-text)]">Kèo chấp</div>
          <div className="flex w-full justify-center text-sm font-semibold text-[var(--theme-text)]">Tài/Xỉu</div>
          <div className="flex w-full justify-center text-sm font-semibold text-[var(--theme-text)]">1X2</div>
        </div>
        <div className="flex min-w-0 flex-1 items-center justify-between gap-2 md:hidden">
          <div className="text-scale-title flex min-w-0 items-center gap-1.5 text-[14px] font-bold leading-5 text-[var(--theme-text)]">
            {logo ? (
              <img src={logo} alt={name || "league"} className="h-[14px] w-[14px] shrink-0 object-contain md:h-4 md:w-4" width={14} height={14} loading="lazy" />
            ) : null}
            <span className="truncate">{name}</span>
          </div>
        </div>

        <div className="absolute right-4 top-1/2 flex -translate-y-1/2 shrink-0 items-center md:right-3">
          <img
            src={ICON_ARROW_UP}
            alt=""
            width={20}
            height={20}
            className={`kbv-corner-icon h-4 w-4 shrink-0 transition-transform md:h-5 md:w-5 ${isExpanded ? "rotate-180" : "rotate-0"}`}
          />
        </div>
      </button>

      {isExpanded ? (
        <div className="bg-[var(--theme-bg)] p-0">
          {matches.map((match) => render(match))}
        </div>
      ) : null}
    </div>
  );
}
